// Phase 85.A.319 — Referee scoring-screen NAVIGATION DIAGNOSTICS
// ---------------------------------------------------------------------------
// Trọng tài báo "đang chấm điểm bị văng về danh sách trận" — chưa rõ là thao
// tác Back/vuốt hay HỆ THỐNG tự điều hướng (mất ws / auth refresh lỗi / route
// guard / offline...). Module này:
//   • Giữ 1 ring-buffer các sự kiện gần đây (offline/online/ws/auth/visibility).
//   • Mỗi khi RỜI màn `/referee/match/:id` → gửi log kèm navType (POP/PUSH/
//     REPLACE) + trail về backend → lưu + đẩy vào Log giải đấu (admin) để
//     truy nguyên nhân THẬT bằng bằng chứng thay vì phỏng đoán.
//
// navType ý nghĩa (React Router):
//   POP     → back trình duyệt / VUỐT CẠNH (gesture) / history.back
//   PUSH    → bấm nút/Link/navigate() (nút Back trong app dùng PUSH)
//   REPLACE → Navigate replace = route guard / RootRedirect (HỆ THỐNG tự đẩy)

const MAX_TRAIL = 60;
let _trail = [];
let _ctx = { matchId: null, tournamentId: null };
let _leaveReason = null;
let _leaveReasonAt = 0;
let _listenersAttached = false;

function _push(type, detail) {
  try {
    _trail.push({ t: Date.now(), type, detail: detail || null });
    if (_trail.length > MAX_TRAIL) _trail = _trail.slice(-MAX_TRAIL);
  } catch {
    /* noop */
  }
}

export function recordDiagEvent(type, detail) {
  _push(type, detail);
}

export function setActiveMatchContext(ctx) {
  _ctx = { matchId: ctx?.matchId || null, tournamentId: ctx?.tournamentId || null };
  _push("match_enter", _ctx);
}

export function clearActiveMatchContext() {
  _ctx = { matchId: null, tournamentId: null };
}

// Đánh dấu lý do rời màn do CHÍNH user chủ động (nút Back / xác nhận rời).
// Có hiệu lực ~3.5s để watcher gắn đúng nguyên nhân.
export function markLeaveReason(reason) {
  _leaveReason = reason;
  _leaveReasonAt = Date.now();
}

function _recentAuthIssue() {
  const cutoff = Date.now() - 8000;
  return _trail.some(
    (e) => e.t >= cutoff &&
      ["auth_refresh_failed", "session_invalidated", "ws_auth_failed", "http_401"].includes(e.type),
  );
}

function _recentNetIssue() {
  const cutoff = Date.now() - 12000;
  return _trail.some((e) => e.t >= cutoff && ["offline", "ws_close"].includes(e.type));
}

function _resolveReason(navType) {
  if (_leaveReason && Date.now() - _leaveReasonAt < 3500) return _leaveReason;
  if (_recentAuthIssue()) return "auth_session_lost";
  if (navType === "POP") return "browser_back_or_swipe";
  if (navType === "REPLACE") return "route_guard_or_auth_redirect";
  if (navType === "PUSH") return "programmatic_navigate";
  return "unknown";
}

export function reportNavLeave({ navType, fromRoute, toRoute }) {
  const reason = _resolveReason(navType);
  const payload = {
    match_id: _ctx.matchId,
    tournament_id: _ctx.tournamentId,
    from_route: fromRoute || null,
    to_route: toRoute || null,
    nav_type: navType || null,
    reason,
    online: typeof navigator !== "undefined" ? navigator.onLine : null,
    net_issue_recent: _recentNetIssue(),
    auth_issue_recent: _recentAuthIssue(),
    ua: typeof navigator !== "undefined" ? navigator.userAgent : "",
    trail: _trail.slice(-40),
  };
  _leaveReason = null; // reset transient reason
  // Lazy import `api` để tránh circular import (api.js cũng dùng module này).
  import("./api")
    .then(({ api }) => api.post("/referee/diag/nav-leave", payload).catch(() => {}))
    .catch(() => {});
}

// Phase 85.A.319b — Báo lỗi ẢNH HƯỞNG TRẬN ĐẤU (mất điểm khi bấm, mất kết nối
// lúc đang chấm, lỗi tải trận...). Lưu ngay vào backend (throttle theo loại để
// tránh spam khi mạng chập chờn) + ghi trail. event_kind="error".
const _lastErrorAt = {};
export function reportDiagError(errorType, detail) {
  _push(errorType, detail || null);
  const now = Date.now();
  if (now - (_lastErrorAt[errorType] || 0) < 15000) return; // throttle 15s/loại
  _lastErrorAt[errorType] = now;
  const payload = {
    event_kind: "error",
    error_type: errorType,
    match_id: _ctx.matchId,
    tournament_id: _ctx.tournamentId,
    online: typeof navigator !== "undefined" ? navigator.onLine : null,
    detail: detail || null,
    ua: typeof navigator !== "undefined" ? navigator.userAgent : "",
    trail: _trail.slice(-30),
  };
  import("./api")
    .then(({ api }) => api.post("/referee/diag/event", payload).catch(() => {}))
    .catch(() => {});
}

export function initRefereeNavDiag() {
  if (_listenersAttached || typeof window === "undefined") return;
  _listenersAttached = true;
  window.addEventListener("offline", () => _push("offline"));
  window.addEventListener("online", () => _push("online"));
  window.addEventListener("pagehide", (e) => _push("pagehide", { persisted: !!e.persisted }));
  window.addEventListener("pageshow", (e) => _push("pageshow", { persisted: !!e.persisted }));
  document.addEventListener("visibilitychange", () =>
    _push(document.visibilityState === "hidden" ? "visibility_hidden" : "visibility_visible"),
  );
}
